export const TAB_ICON_DIMENSION = 20;

export const TAB_ICON_PROPS = {
  width: TAB_ICON_DIMENSION,
  height: TAB_ICON_DIMENSION,
};
